<template>
  <b-container fluid>
    <b-navbar
      fixed='top'
      toggleable='sm'
      type='dark'
      variant='primary'>

      <b-navbar-brand>
        Ward Notification Pager
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>

      <b-navbar-nav v-if="loggedIn">
          <b-nav-item v-if="myWardId!==null && isInRole('canReadWard')"  active-class="active" :to="{name: 'ward-list', params: { 'wardId': myWardId}}">
            My Ward
          </b-nav-item>
          <b-nav-item v-if="myStakeId!==null && isInRole('canReadStake')" active-class="active" :to="{name: 'stake-detail', params: { 'stakeId': myStakeId}}">
            My Stake
          </b-nav-item>
          <b-nav-item v-if="loggedIn && isInRole('canListStakes')" active-class="active" to="/stakes">
            Stakes
          </b-nav-item>
          <b-nav-item v-if="loggedIn && isInRole('canAdminMobileCarriers')" active-class="active" to="/carriers">
            Carriers
          </b-nav-item>
          <b-nav-item v-if="loggedIn && isInRole('canViewUsers')" active-class="active" to="/users">
            Users
          </b-nav-item>
      </b-navbar-nav>
        <b-navbar-nav v-if="!loggedIn">
          <b-nav-item active-class="active" to="/">Home</b-nav-item>
          <b-nav-item active-class="active" to="/features">Features</b-nav-item>
          <b-nav-item active-class="active" to="/about">FAQ</b-nav-item>
          <b-nav-item active-class="active" to="/contact">Request Demo</b-nav-item>
          <b-nav-item active-class="active" to="/login">Login</b-nav-item>
        </b-navbar-nav>
      <b-navbar-nav class='ml-auto'>

        <b-nav-item v-if="loggedIn && isInRole('canAdminMobileCarriers')"
                    :href='docsUrl'
                    class='mr-3'
                    target='_blank'>
          <font-awesome-icon icon='book'/>
        </b-nav-item>
       <b-nav-item-dropdown right v-if="loggedIn">
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em><font-awesome-icon :icon="['fa', 'user']"/></em>
          </template>
          <b-dropdown-item href='/user/me'>My User</b-dropdown-item>
          <b-dropdown-item href='/logout'><font-awesome-icon :icon="['fa', 'sign-out-alt']"/> Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </b-container>
</template>

<script>
import { userMixin } from "@/mixins/userMixin";

export default {
  name: 'MainNavbar',
  mixins: [userMixin],
  computed: {
    docsUrl () {
      return process.env.VUE_APP_DOCS_URL
    },
    loggedIn () {
      let loggedIn = !this.userTokenExpired;
      console.log(`LoggedIn: ${loggedIn}`);
      return loggedIn;
    },
    myWardId () {
      return this.$store.state.user.ward_id || null;
    },
    myStakeId () {
      return this.$store.state.user.stake_id || null;
    }
  },
  methods: {}
}
</script>

<style lang='scss'
       scoped>

//.navbar-brand {
//  img {
//    height: 55px;
//    margin-right: 20px;
//    margin-top: -20px;
//    margin-bottom: -20px;
//  }
//}

</style>
